import SliderButton from './Buttons/SliderButton';

export const rules = [
  { maxWidth: 2000, elements: 6 },
  { maxWidth: 1280, elements: 3 },
  { maxWidth: 768, elements: 3 },
  { maxWidth: 640, elements: 2 },
];

export const simpleSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  nextArrow: (
    <SliderButton classNameIcon="w-3 h-3 transition-transform duration-300 hover:scale-150" />
  ),
  prevArrow: (
    <SliderButton classNameIcon="w-3 h-3 transition-transform duration-300 hover:scale-150 rotate-180" />
  ),
};

export const getSettings = (array, autoPlay: boolean = false) => ({
  dots: true,
  infinite: false,
  ...(autoPlay
    ? {
        autoplay: true,
        speed: 2000,
        autoplaySpeed: 3000,
        cssEase: 'linear',
      }
    : {}),
  responsive: [
    {
      breakpoint: 2000,
      settings: {
        ...(autoPlay
          ? {
              slidesToShow: 5,
            }
          : {
              slidesToShow: array.length > 3 ? 4 : array.length,
              className: 'center',
              centerMode: true,
              centerPadding: '1px',
            }),
        slidesToScroll: 1,
        infinite: array.length > 1,
      },
    },
    {
      breakpoint: 1050,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: array.length > 1,
        className: 'center',
        centerMode: true,
        centerPadding: '1px',
      },
    },
    {
      breakpoint: 800,
      settings: {
        className: 'center',
        centerMode: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 3,
        infinite: array.length > 1,
      },
    },
    {
      breakpoint: 700,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 2,
        infinite: array.length > 1,
        ...(autoPlay
          ? {
              centerPadding: '20px',
              className: 'center',
              centerMode: true,
            }
          : {}),
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: array.length > 1,
        ...(autoPlay
          ? {
              centerPadding: '20px',
              className: 'center',
              centerMode: true,
            }
          : {}),
      },
    },
  ],
  nextArrow: (
    <SliderButton classNameIcon="w-3 h-3 transition-transform duration-300 hover:scale-150" />
  ),
  prevArrow: (
    <SliderButton classNameIcon="w-3 h-3 transition-transform duration-300 hover:scale-150 rotate-180" />
  ),
});
